var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltipOrLabel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 26,
    viewBox: "0 0 54 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tooltip-or-label",
    transform: "translate(-364 -167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pol\\xEDgono_2",
    "data-name": "Pol\\xEDgono 2",
    transform: "translate(400 193) rotate(180)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.88975238800049 10 L 2.110247373580933 10 L 9 1.579191088676453 L 15.88975238800049 10 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9 3.158370018005371 L 4.220484733581543 9 L 13.77951526641846 9 L 9 3.158370018005371 M 9 0 L 18 11 L 0 11 L 9 0 Z",
    stroke: "none",
    fill: "#ff770e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_7",
    "data-name": "Rect\\xE1ngulo 7",
    transform: "translate(364 167)",
    fill: "#fff",
    stroke: "#ff770e",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 19,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 52,
    height: 17,
    rx: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_8",
    "data-name": "Rect\\xE1ngulo 8",
    width: 5,
    height: 5.5,
    transform: "translate(388.5 181)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipOrLabel);
export default __webpack_public_path__ + "static/media/tooltip-or-label.47ee6b8bf835911559ff79a336433f44.svg";
export { ForwardRef as ReactComponent };